var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between items-center py-2 md:py-5 border-t border-b border-gray-100"},[_c('AtomTitle',{staticClass:"w-1/2",attrs:{"tag":"h2","sup":_vm.control.titleSup}},[_vm._v(_vm._s(_vm.control.title))]),_vm._v(" "),_c('AtomButton',{attrs:{"to":_vm.control.to}},[_vm._v(_vm._s(_vm.control.button))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }